module.exports = __webpack_public_path__ + "img/04.d35c54c6.png";